import { pick } from 'ramda';
import api from './api';

export const validateStopMerge = async (
  depotCode,
  routeId,
  parcels,
  checkOpenRequests,
  shopUnsuitable,
  splitStop,
  routePlannerDowngrades,
  parcelValidated
) => {
  const { data } = await api.post(
    `/depot/${depotCode}/route/${routeId}/stop/validate`,
    null,
    null,
    {
      parcel: parcels.map((parcel) =>
        pick(['parcelCode', 'routeDate'], parcel)
      ),
      checkOpenRequests,
      shopUnsuitable,
      splitStop,
      routePlannerDowngrades,
      parcelValidated,
    }
  );

  return data;
};
